import { render } from "./Section.vue?vue&type=template&id=9bc63e74"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"

import "./Section.vue?vue&type=style&index=0&id=9bc63e74&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__